import { NavLink, useLocation } from 'react-router-dom'
import { MenuItem } from '@interfaces/index'
import './ClosedSideMenu.scss'
import { focusableRoutes, routes } from '@constants/routes.const'
import { setMenuIcon } from '../menuIcons'
import { ProfileIcon } from '@components/Profile/ProfileIcon/ProfileIcon'
import { LocalStorageItem } from '@constants/index'
import { KidsTagVariant } from '@enums/profile.enum'

interface ClosedSideMenuPros {
  closedMenuAnimation: boolean
  menuItems?: MenuItem[]
}

export const ClosedSideMenu = ({ menuItems }: ClosedSideMenuPros) => {
  const activeProfileObject = JSON.parse(localStorage.getItem(LocalStorageItem.ACTIVE_PROFILE) as string)
  const location = useLocation()

  return (
    <div className="closed-side-menu">
      <div className="closed-side-menu-items">
        <NavLink
          className={({ isActive }) =>
            `${
              isActive && location.pathname === routes.MANAGE_PROFILES ? 'active ' : ''
            }closed-side-menu-profile-image-container`
          }
          to={routes.MANAGE_PROFILES}
        >
          <div
            className="closed-side-menu-profile-image"
            style={{ backgroundColor: activeProfileObject?.image.backgroundColor }}
          >
            <ProfileIcon profileData={activeProfileObject} kidsTagVariant={KidsTagVariant.MENU} />
          </div>
        </NavLink>
        <div className="closed-side-menu-icons-container">
          {menuItems?.map((menuItem, index) => {
            return (
              <NavLink
                to={`${menuItem.path}`}
                id={`${focusableRoutes.MENU}-item-${index}`}
                className={({ isActive }) => (isActive && location.pathname === menuItem.path ? 'active' : '')}
                key={menuItem.text}
              >
                {setMenuIcon(menuItem.icon)}
                <div className="side-menu-border"></div>
              </NavLink>
            )
          })}
        </div>
      </div>
    </div>
  )
}
